import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Accordion } from 'semantic-ui-react';
import Link from '../../../../../lib/components/link';
import { MenuItemType } from '../../../../../lib/proptypes/menu.proptypes';
import classes from './sidebar.css';
import angleIcon from '../../../../../assets/images/icon-arrow-dark.svg';

const MyHuddleTitle = () => (
  <Accordion.Title className={classes.myHuddleTitle}>
    <span className={classes.myHuddleTitleText}>myHUDDLE</span>
    <span className={classes.iconContainer}>
      <img src={angleIcon} alt="Dropdown arrow" />
    </span>
  </Accordion.Title>
);

const MyHuddleContent = menu =>
  (<Accordion.Content className={classes.myHuddleContent}>
    {menu.map(
      item =>
        (item.action || item.url) &&
        <div key={item.key} className={classes.myHuddleDropDownItem}>
          <Link className={classes.myHuddleLink} {...item} />
        </div>,
    )}
  </Accordion.Content>);

const myHuddleDropDown = ({ menu }) =>
  (<Accordion className={classes.myHuddleMenu}>
    {MyHuddleTitle()}
    {MyHuddleContent(menu)}
  </Accordion>);

myHuddleDropDown.propTypes = {
  menu: PropTypes.arrayOf(MenuItemType).isRequired,
};

const mapStateToProps = state => ({
  menu: state.nav.header,
});

export default connect(mapStateToProps)(myHuddleDropDown);



// WEBPACK FOOTER //
// ./src/app/components/Nav/MobileNav/Sidebar/MyHuddleAccordion.js